import React, { useEffect, useState } from 'react';
import Heading from '../../common/Heading/Heading';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { queryKeys } from '../../../services/react-query/queryKeys';
import { getCompany, updateCompany } from '../../../network/profile';
import {
  Button,
  Card,
  Checkbox,
  Col,
  DatePicker,
  Divider,
  Form,
  Input,
  message,
  Row,
  Select,
  Spin,
} from 'antd';
import { getSearchApi, getSearchApiAcount } from '../../../network/itemList';
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import dayjs from 'dayjs';
import PhoneInputWithCountrySelect, {
  isValidPhoneNumber,
} from 'react-phone-number-input';

const EditProfile = ({ t }) => {
  const [form] = Form.useForm();
  const [loadingAdd, setLoadingAdd] = useState(false);
  const client = useQueryClient();
  const navigate = useNavigate();
  const [searchtextAccount, setSearchtextAccount] = useState('');
  const [searchTextCostCenter, setSearchTextCostCenter] = useState('');
  const [searchTextWarehouse, setSearchTextWarehouse] = useState('');
  // const [searchTextWarehouse, setSearchTextWarehouse] = useState('');

  const { companyName } = useSelector((state) => state.user);
  const { id } = useParams();
  const { mutate: onUpdateCompany } = useMutation({
    mutationKey: ['updateCompany'],
    mutationFn: (body) => updateCompany(body, id),
    onSuccess: (data) => {
      setLoadingAdd(false);
      console.log(data?.message, 'datawwww');
      if (data?.message?.status === 500) {
        message.error(data?.message?.message);
        return false;
      }
      navigate('/profile');
      message.success('Updated successfully');
      client.invalidateQueries({ queryKey: [queryKeys.getCompany] });
    },
    onError: (error) => {
      setLoadingAdd(false);
      const serverMessages = JSON.parse(error.response.data._server_messages);
      const messageData = JSON.parse(serverMessages[0]);
      const title = messageData.title || 'Error';
      const messageContent = messageData.message || 'An error occurred';
      message.error({
        content: `${title}: ${messageContent.replace(/<[^>]*>/g, '')}`,
        duration: 5,
      });
    },
  });
  const { data, isLoading } = useQuery({
    queryKey: [queryKeys.getCompany],
    queryFn: () => getCompany(id),
    keepPreviousData: true,
  });

  const { data: holidayList } = useQuery({
    queryKey: [queryKeys.getSearchApiHolidayList],
    queryFn: () => getSearchApi('Holiday List'),
    keepPreviousData: true,
  });

  const { data: accountsList } = useQuery({
    queryKey: [queryKeys.getSearchApiAccountList, searchtextAccount],
    queryFn: () =>
      getSearchApiAcount({ type: 'Account', searchTxt: searchtextAccount }),
    keepPreviousData: true,
    enabled: searchtextAccount?.length >= 3 || searchtextAccount?.length === 0,
  });

  const { data: costCenters } = useQuery({
    queryKey: [queryKeys.getSearchApiCostCenter, searchTextCostCenter],
    queryFn: () =>
      getSearchApiAcount({
        type: 'Cost Center',
        searchTxt: searchTextCostCenter,
      }),
    enabled:
      searchTextCostCenter?.length >= 3 || searchTextCostCenter?.length === 0,
    keepPreviousData: true,
  });

  const { data: warehouses } = useQuery({
    queryKey: [queryKeys.getSearchApiWarehouse, searchTextWarehouse],
    queryFn: () =>
      getSearchApiAcount({ type: 'Warehouse', searchTxt: searchTextWarehouse }),
    keepPreviousData: true,
    enabled:
      searchTextWarehouse?.length >= 3 || searchTextWarehouse?.length === 0,
  });

  const onFinish = (values) => {
    setLoadingAdd(true);
    onUpdateCompany({
      ...values,
      date_of_establishment: dayjs(values?.date_of_establishment).format(
        'YYYY-MM-DD'
      ),
      allow_account_creation_against_child_company:
        values?.allow_account_creation_against_child_company ? 1 : 0,
      enable_perpetual_inventory: values?.enable_perpetual_inventory ? 1 : 0,
      auto_exchange_rate_revaluation: values?.auto_exchange_rate_revaluation
        ? 1
        : 0,
      enable_provisional_accounting_for_non_stock_items:
        values?.enable_provisional_accounting_for_non_stock_items ? 1 : 0,
    });
  };

  useEffect(() => {
    if (data?.data && id) {
      form.setFieldsValue({
        ...data?.data,

        date_of_establishment: dayjs(data?.data?.date_of_establishment),
      });
    }
  }, [data, id]);
  const generateSelectOptions = (data) =>
    data?.message?.map((item) => ({
      value: item?.value,
      label: item?.value,
    }));
  if (isLoading) {
    return (
      <div
        style={{
          width: '100%',
          height: '100vh',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Spin size="large" />
      </div>
    );
  }

  return (
    <>
      <div className="">
        <Heading title={t.profile} subTitle={t.editProfile} path="/profile" />
        <Card
          title={
            <h2
              style={{
                textTransform: 'capitalize',
                // marginBottom: "20px",
              }}
            >
              {t.editProfile} {companyName}
            </h2>
          }
        >
          {/* <h2 
           style={{
            textTransform:"uppercase",
            marginBottom: "20px",
           }}
          >{t.editProfile}  {companyName}</h2> */}
          <Form
            form={form}
            name="edit-profile-form"
            layout="vertical"
            onFinish={onFinish}
            style={{ marginTop: '20px' }}
          >
            <Divider orientation="left">{t.CompanyInformation}</Divider>
            <Row gutter={[16, 16]}>
              <Col xs={24} md={12} xl={8}>
                <Form.Item
                  name="company_name_in_arabic"
                  label={t.companyNameInArabic}
                  // rules={[{ required: true }]}
                >
                  <Input placeholder={t.companyNameInArabic} />
                </Form.Item>
              </Col>
              <Col xs={24} md={12} xl={8}>
                <Form.Item
                  name="default_holiday_list"
                  label={t.holidaylist}
                  // rules={[{ required: true }]}
                >
                  <Select
                    showSearch
                    allowClear
                    filterOption={false}
                    onChange={(value) => {
                      console.log(value);
                    }}
                    placeholder={t.holidaylist}
                    options={generateSelectOptions(holidayList)}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} md={12} xl={8}>
                <Form.Item
                  name="tax_id"
                  label={t.taxId}
                  // rules={[{ required: true }]}
                >
                  <Input placeholder={t.taxId} />
                </Form.Item>
              </Col>
              <Col xs={24} md={12} xl={8}>
                <Form.Item
                  name="date_of_establishment"
                  label={t.dateOfEstablishment}
                  // rules={[{ required: true }]}
                >
                  <DatePicker
                    placeholder={t.dateOfEstablishment}
                    style={{ width: '100%' }}
                    format="YYYY-MM-DD"
                  />
                </Form.Item>
              </Col>
              <Col xs={24} md={12} xl={8}>
                <Form.Item
                  name="custom_cr_number"
                  label={t.customCrNumber}
                  rules={[{ required: true }]}
                >
                  <Input placeholder={t.customCrNumber} type="number" />
                </Form.Item>
              </Col>
              <Col xs={24} md={12} xl={8}>
                <Form.Item
                  name="phone_no"
                  label={t.phoneNumber}
                  className="w-full"
                  rules={[
                    {
                      validator: (rule, value) => {
                        console.log(value, 'value');
                        if (isValidPhoneNumber(value)) {
                          return Promise.resolve();
                        }
                        return Promise.reject('رقم الجوال غير صالح');
                      },
                    },
                  ]}
                  hasFeedback
                >
                  <PhoneInputWithCountrySelect
                    defaultCountry="SA"
                    className="w-full"
                    name="phone"
                    label={t.phoneNumber}
                    international
                    hasFeedback
                    limitMaxLength={true}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} md={12} xl={8}>
                <Form.Item
                  name="email"
                  label={t.email}
                  rules={[
                    // { required: true },
                    {
                      type: 'email',
                      message: 'The input is not valid E-mail!',
                    },
                  ]}
                >
                  <Input placeholder={t.email} type="email" />
                </Form.Item>
              </Col>
              <Col xs={24} md={12} xl={8}>
                <Form.Item
                  name="website"
                  label={t.website}
                  // rules={[{ required: true }]}
                >
                  <Input placeholder={t.website} />
                </Form.Item>
              </Col>
              <Col xs={24} md={12} xl={8}>
                <Form.Item
                  name="company_name"
                  label={t.companyName}
                  // rules={[{ required: true }]}
                >
                  <Input placeholder={t.companyName} disabled />
                </Form.Item>
              </Col>
              <Col xs={24} md={12} xl={8}>
                <Form.Item
                  name="abbr"
                  label={t.abbr}
                  rules={[{ required: true }]}
                >
                  <Input placeholder={t.abbr} disabled />
                </Form.Item>
              </Col>
              <Col xs={24} md={12} xl={8}>
                <Form.Item
                  name="default_currency"
                  label={t.currency}
                  rules={[{ required: true }]}
                >
                  <Input placeholder={t.currency} disabled />
                </Form.Item>
              </Col>
              <Col xs={24} md={12} xl={8}>
                <Form.Item
                  name="country"
                  label={t.country}
                  rules={[{ required: true }]}
                >
                  <Input placeholder={t.country} disabled />
                </Form.Item>
              </Col>

              <Col span={24}>
                <Form.Item
                  name="company_description"
                  label={t.companyDescription}
                  // rules={[{ required: true }]}
                >
                  <Input.TextArea
                    autoSize={{ minRows: 4, maxRows: 4 }}
                    placeholder={t.companyDescription}
                  />
                </Form.Item>
              </Col>
              <Divider orientation="left"> {t.BuyingSellingSettings} </Divider>
              <Col xs={24} md={12} xl={8}>
                <Form.Item
                  name="monthly_sales_target"
                  label={t.monthlySalesTarget}
                  // rules={[{ required: true }]}
                >
                  <Input placeholder={t.monthlySalesTarget} type="number" />
                </Form.Item>
              </Col>
              <Col xs={24} md={12} xl={8}>
                <Form.Item
                  name="total_monthly_sales"
                  label={t.totalMonthlySales}
                  // rules={[{ required: true }]}
                >
                  <Input placeholder={t.totalMonthlySales} />
                </Form.Item>
              </Col>
              <Col xs={24} md={12} xl={8}>
                <Form.Item
                  name="credit_limit"
                  label={t.creditLimit}
                  // rules={[{ required: true }]}
                >
                  <Input placeholder={t.creditLimit} />
                </Form.Item>
              </Col>
              <Col xs={24} md={12} xl={8}>
                <Form.Item
                  name="custom_default_down_payment_item"
                  label={t.customDefaultDownPaymentItem}
                  // rules={[{ required: true }]}
                >
                  <Input placeholder={t.customDefaultDownPaymentItem} />
                </Form.Item>
              </Col>
              <Divider orientation="left">{t.HRPayrollSettings}</Divider>

              <Col xs={24} md={12} xl={8}>
                <Form.Item
                  name="default_expense_claim_payable_account"
                  label={t.defaultExpenseClaimPayableAccount}
                  // rules={[{ required: true }]}
                >
                  <Select
                    showSearch
                    allowClear
                    filterOption={false}
                    onSearch={(value) => {
                      setSearchtextAccount(value);
                    }}
                    onChange={(value) => {
                      // console.log(value);
                      setSearchtextAccount('');
                    }}
                    placeholder={t.defaultExpenseClaimPayableAccount}
                    options={generateSelectOptions(accountsList)}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} md={12} xl={8}>
                <Form.Item
                  name="default_employee_advance_account"
                  label={t.defaultEmployeeAdvanceAccount}
                  // rules={[{ required: true }]}
                >
                  <Select
                    showSearch
                    allowClear
                    filterOption={false}
                    onSearch={(value) => {
                      setSearchtextAccount(value);
                    }}
                    onChange={(value) => {
                      // console.log(value);
                      setSearchtextAccount('');
                    }}
                    placeholder={t.defaultExpenseClaimPayableAccount}
                    options={generateSelectOptions(accountsList)}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} md={12} xl={8}>
                <Form.Item
                  name="default_expense_claim_payable_account"
                  label={t.defaultExpenseClaimPayableAccount}
                  // rules={[{ required: true }]}
                >
                  <Select
                    showSearch
                    allowClear
                    filterOption={false}
                    onChange={(value) => {
                      // console.log(value);
                      setSearchtextAccount('');
                    }}
                    onSearch={(value) => {
                      setSearchtextAccount(value);
                    }}
                    placeholder={t.defaultExpenseClaimPayableAccount}
                    options={generateSelectOptions(accountsList)}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} md={12} xl={8}>
                <Form.Item
                  name="default_payroll_payable_account"
                  label={t.defaultPayrollPayableAccount}
                  // rules={[{ required: true }]}
                >
                  <Select
                    showSearch
                    allowClear
                    filterOption={false}
                    onSearch={(value) => {
                      setSearchtextAccount(value);
                    }}
                    onChange={(value) => {
                      // console.log(value);
                      setSearchtextAccount('');
                    }}
                    placeholder={t.defaultPayrollPayableAccount}
                    options={generateSelectOptions(accountsList)}
                  />
                </Form.Item>
              </Col>
              <Divider orientation="left">{t.AccountsSettings}</Divider>
              <Col xs={24} md={12} xl={8}>
                <Form.Item
                  name="default_bank_account"
                  label={t.defaultBankAccount}
                  // rules={[{ required: true }]}
                >
                  <Select
                    showSearch
                    allowClear
                    filterOption={false}
                    onChange={(value) => {
                      // console.log(value);
                      setSearchtextAccount('');
                    }}
                    onSearch={(value) => {
                      setSearchtextAccount(value);
                    }}
                    placeholder={t.defaultBankAccount}
                    options={generateSelectOptions(accountsList)}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} md={12} xl={8}>
                <Form.Item
                  name="default_receivable_account"
                  label={t.defaultReceivableAccount}
                  // rules={[{ required: true }]}
                >
                  <Select
                    showSearch
                    allowClear
                    filterOption={false}
                    onChange={(value) => {
                      // console.log(value);
                      setSearchtextAccount('');
                    }}
                    onSearch={(value) => {
                      setSearchtextAccount(value);
                    }}
                    placeholder={t.defaultReceivableAccount}
                    options={generateSelectOptions(accountsList)}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} md={12} xl={8}>
                <Form.Item
                  name="default_cash_account"
                  label={t.defaultCashAccount}
                  // rules={[{ required: true }]}
                >
                  <Select
                    showSearch
                    allowClear
                    filterOption={false}
                    onChange={(value) => {
                      // console.log(value);
                      setSearchtextAccount('');
                    }}
                    onSearch={(value) => {
                      setSearchtextAccount(value);
                    }}
                    placeholder={t.defaultCashAccount}
                    options={generateSelectOptions(accountsList)}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} md={12} xl={8}>
                <Form.Item
                  name="round_off_account"
                  label={t.roundOffAccount}
                  // rules={[{ required: true }]}
                >
                  <Select
                    showSearch
                    allowClear
                    filterOption={false}
                    onChange={(value) => {
                      // console.log(value);
                      setSearchtextAccount('');
                    }}
                    onSearch={(value) => {
                      setSearchtextAccount(value);
                    }}
                    placeholder={t.roundOffAccount}
                    options={generateSelectOptions(accountsList)}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} md={12} xl={8}>
                <Form.Item
                  name="round_off_cost_center"
                  label={t.roundOffCostCenter}
                  // rules={[{ required: true }]}
                >
                  <Select
                    showSearch
                    allowClear
                    filterOption={false}
                    onChange={(value) => {
                      // console.log(value);
                      setSearchTextCostCenter('');
                    }}
                    onSearch={(value) => {
                      setSearchTextCostCenter(value);
                    }}
                    placeholder={t.roundOffCostCenter}
                    options={generateSelectOptions(costCenters)}
                  />
                </Form.Item>
              </Col>

              <Col xs={24} md={12} xl={8}>
                <Form.Item
                  name="write_off_account"
                  label={t.writeOffAccount}
                  // rules={[{ required: true }]}
                >
                  <Select
                    showSearch
                    allowClear
                    filterOption={false}
                    onChange={(value) => {
                      // console.log(value);
                      setSearchtextAccount('');
                    }}
                    onSearch={(value) => {
                      setSearchtextAccount(value);
                    }}
                    placeholder={t.writeOffAccount}
                    options={generateSelectOptions(accountsList)}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} md={12} xl={8}>
                <Form.Item
                  name="exchange_gain_loss_account"
                  label={t.exchangeGainLossAccount}
                  // rules={[{ required: true }]}
                >
                  <Select
                    showSearch
                    allowClear
                    filterOption={false}
                    onChange={(value) => {
                      // console.log(value);
                      setSearchtextAccount('');
                    }}
                    onSearch={(value) => {
                      setSearchtextAccount(value);
                    }}
                    placeholder={t.exchangeGainLossAccount}
                    options={generateSelectOptions(accountsList)}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} md={12} xl={8}>
                <Form.Item
                  name="custom_advance_payment_account"
                  label={t.customAdvancePaymentAccount}
                  // rules={[{ required: true }]}
                >
                  <Select
                    showSearch
                    allowClear
                    filterOption={false}
                    onChange={(value) => {
                      // console.log(value);
                      setSearchtextAccount('');
                    }}
                    onSearch={(value) => {
                      setSearchtextAccount(value);
                    }}
                    placeholder={t.customAdvancePaymentAccount}
                    options={generateSelectOptions(accountsList)}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} md={12} xl={8}>
                <Form.Item
                  name="unrealized_profit_loss_account"
                  label={t.unrealizedProfitLossAccount}
                  // rules={[{ required: true }]}
                >
                  <Select
                    showSearch
                    allowClear
                    filterOption={false}
                    onChange={(value) => {
                      // console.log(value);
                      setSearchtextAccount('');
                    }}
                    onSearch={(value) => {
                      setSearchtextAccount(value);
                    }}
                    placeholder={t.unrealizedProfitLossAccount}
                    options={generateSelectOptions(accountsList)}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} md={12} xl={8}>
                <Form.Item
                  name="allow_account_creation_against_child_company"
                  label={t.allowAccountCreationAgainstChildCompany}
                  // rules={[{ required: true }]}
                >
                  <Select
                    showSearch
                    allowClear
                    filterOption={false}
                    onChange={(value) => {
                      // console.log(value);
                      setSearchtextAccount('');
                    }}
                    onSearch={(value) => {
                      setSearchtextAccount(value);
                    }}
                    placeholder={t.allowAccountCreationAgainstChildCompany}
                    options={generateSelectOptions(accountsList)}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} md={12} xl={8}>
                <Form.Item
                  name="default_payable_account"
                  label={t.defaultPayableAccount}
                  // rules={[{ required: true }]}
                >
                  <Select
                    showSearch
                    allowClear
                    filterOption={false}
                    onChange={(value) => {
                      // console.log(value);
                      setSearchtextAccount('');
                    }}
                    onSearch={(value) => {
                      setSearchtextAccount(value);
                    }}
                    placeholder={t.defaultPayableAccount}
                    options={generateSelectOptions(accountsList)}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} md={12} xl={8}>
                <Form.Item
                  name="default_expense_account"
                  label={t.defaultExpenseAccount}
                  // rules={[{ required: true }]}
                >
                  <Select
                    showSearch
                    allowClear
                    filterOption={false}
                    onChange={(value) => {
                      // console.log(value);
                      setSearchtextAccount('');
                    }}
                    onSearch={(value) => {
                      setSearchtextAccount(value);
                    }}
                    placeholder={t.defaultExpenseAccount}
                    options={generateSelectOptions(accountsList)}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} md={12} xl={8}>
                <Form.Item
                  name="default_income_account"
                  label={t.defaultIncomeAccount}
                  // rules={[{ required: true }]}
                >
                  <Select
                    showSearch
                    allowClear
                    filterOption={false}
                    onChange={(value) => {
                      // console.log(value);
                      setSearchtextAccount('');
                    }}
                    onSearch={(value) => {
                      setSearchtextAccount(value);
                    }}
                    placeholder={t.defaultIncomeAccount}
                    options={generateSelectOptions(accountsList)}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} md={12} xl={8}>
                <Form.Item
                  name="default_deferred_revenue_account"
                  label={t.defaultDeferredRevenueAccount}
                  // rules={[{ required: true }]}
                >
                  <Select
                    showSearch
                    allowClear
                    filterOption={false}
                    onChange={(value) => {
                      // console.log(value);
                      setSearchtextAccount('');
                    }}
                    onSearch={(value) => {
                      setSearchtextAccount(value);
                    }}
                    placeholder={t.defaultDeferredRevenueAccount}
                    options={generateSelectOptions(accountsList)}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} md={12} xl={8}>
                <Form.Item
                  name="default_deferred_expense_account"
                  label={t.defaultDeferredExpenseAccount}
                  // rules={[{ required: true }]}
                >
                  <Select
                    showSearch
                    allowClear
                    filterOption={false}
                    onChange={(value) => {
                      // console.log(value);
                      setSearchtextAccount('');
                    }}
                    onSearch={(value) => {
                      setSearchtextAccount(value);
                    }}
                    placeholder={t.defaultDeferredExpenseAccount}
                    options={generateSelectOptions(accountsList)}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} md={12} xl={8}>
                <Form.Item
                  name="default_discount_account"
                  label={t.defaultDiscountAccount}
                  // rules={[{ required: true }]}
                >
                  <Select
                    showSearch
                    allowClear
                    filterOption={false}
                    onChange={(value) => {
                      // console.log(value);
                      setSearchtextAccount('');
                    }}
                    onSearch={(value) => {
                      setSearchtextAccount(value);
                    }}
                    placeholder={t.defaultDiscountAccount}
                    options={generateSelectOptions(accountsList)}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} md={12} xl={8}>
                <Form.Item
                  name="cost_center"
                  label={t.costCenter}
                  // rules={[{ required: true }]}
                >
                  <Select
                    showSearch
                    allowClear
                    filterOption={false}
                    onChange={(value) => {
                      // console.log(value);
                      setSearchTextCostCenter('');
                    }}
                    onSearch={(value) => {
                      setSearchTextCostCenter(value);
                    }}
                    placeholder={t.costCenter}
                    options={generateSelectOptions(costCenters)}
                  />
                </Form.Item>
              </Col>
              <Divider orientation="left">{t.StockSettings}</Divider>

              <Col
                xs={24}
                md={12}
                xl={8}
                className="flex items-center justify-start"
              >
                <Form.Item
                  name="enable_perpetual_inventory"
                  valuePropName="checked"
                >
                  <Checkbox>{t.enablePerpetualInventory}</Checkbox>
                </Form.Item>
              </Col>
              <Col
                xs={24}
                md={12}
                xl={8}
                className="flex items-center justify-start"
              >
                <Form.Item
                  name="enable_provisional_accounting_for_non_stock_items"
                  valuePropName="checked"
                >
                  <Checkbox>
                    {t.enableProvisionalAccountingForNonStockItems}
                  </Checkbox>
                </Form.Item>
              </Col>
              <Col xs={24} md={12} xl={8}>
                <Form.Item
                  name="default_inventory_account"
                  label={t.defaultInventoryAccount}
                  // rules={[{ required: true }]}
                >
                  <Select
                    showSearch
                    allowClear
                    filterOption={false}
                    onChange={(value) => {
                      // console.log(value);
                      setSearchtextAccount('');
                    }}
                    onSearch={(value) => {
                      setSearchtextAccount(value);
                    }}
                    placeholder={t.defaultInventoryAccount}
                    options={generateSelectOptions(accountsList)}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} md={12} xl={8}>
                <Form.Item
                  name="stock_adjustment_account"
                  label={t.stockAdjustmentAccount}
                  // rules={[{ required: true }]}
                >
                  <Select
                    showSearch
                    allowClear
                    filterOption={false}
                    onChange={(value) => {
                      // console.log(value);
                      setSearchtextAccount('');
                    }}
                    onSearch={(value) => {
                      setSearchtextAccount(value);
                    }}
                    placeholder={t.stockAdjustmentAccount}
                    options={generateSelectOptions(accountsList)}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} md={12} xl={8}>
                <Form.Item
                  name="stock_received_but_not_billed"
                  label={t.stockReceivedButNotBilled}
                  // rules={[{ required: true }]}
                >
                  <Select
                    showSearch
                    allowClear
                    filterOption={false}
                    onChange={(value) => {
                      // console.log(value);
                      setSearchtextAccount('');
                    }}
                    onSearch={(value) => {
                      setSearchtextAccount(value);
                    }}
                    placeholder={t.stockReceivedButNotBilled}
                    options={generateSelectOptions(accountsList)}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} md={12} xl={8}>
                <Form.Item
                  name="default_provisional_account"
                  label={t.defaultProvisionalAccount}
                  // rules={[{ required: true }]}
                >
                  <Select
                    showSearch
                    allowClear
                    filterOption={false}
                    onChange={(value) => {
                      // console.log(value);
                      setSearchtextAccount('');
                    }}
                    onSearch={(value) => {
                      setSearchtextAccount(value);
                    }}
                    placeholder={t.defaultProvisionalAccount}
                    options={generateSelectOptions(accountsList)}
                  />
                </Form.Item>
              </Col>
              <Divider orientation="left">{t.FixedAssetSettings}</Divider>
              <Col xs={24} md={12} xl={8}>
                <Form.Item
                  name="accumulated_depreciation_account"
                  label={t.accumulatedDepreciationAccount}
                  // rules={[{ required: true }]}
                >
                  <Select
                    showSearch
                    allowClear
                    filterOption={false}
                    onChange={(value) => {
                      // console.log(value);
                      setSearchtextAccount('');
                    }}
                    onSearch={(value) => {
                      setSearchtextAccount(value);
                    }}
                    placeholder={t.accumulatedDepreciationAccount}
                    options={generateSelectOptions(accountsList)}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} md={12} xl={8}>
                <Form.Item
                  name="depreciation_expense_account"
                  label={t.depreciationExpenseAccount}
                  // rules={[{ required: true }]}
                >
                  <Select
                    showSearch
                    allowClear
                    filterOption={false}
                    onChange={(value) => {
                      // console.log(value);
                      setSearchtextAccount('');
                    }}
                    onSearch={(value) => {
                      setSearchtextAccount(value);
                    }}
                    placeholder={t.depreciationExpenseAccount}
                    options={generateSelectOptions(accountsList)}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} md={12} xl={8}>
                <Form.Item
                  name="series_for_depreciation_entry"
                  label={t.SeriesForDepreciationEntry}
                  // rules={[{ required: true }]}
                >
                  <Input placeholder={t.SeriesForDepreciationEntry} />
                </Form.Item>
              </Col>
              <Col xs={24} md={12} xl={8}>
                <Form.Item
                  name="disposal_account"
                  label={t.disposalAccount}
                  // rules={[{ required: true }]}
                >
                  <Select
                    showSearch
                    allowClear
                    filterOption={false}
                    onChange={(value) => {
                      // console.log(value);
                      setSearchtextAccount('');
                    }}
                    onSearch={(value) => {
                      setSearchtextAccount(value);
                    }}
                    placeholder={t.disposalAccount}
                    options={generateSelectOptions(accountsList)}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} md={12} xl={8}>
                <Form.Item
                  name="depreciation_cost_center"
                  label={t.depreciationCostCenter}
                  // rules={[{ required: true }]}
                >
                  <Select
                    showSearch
                    allowClear
                    filterOption={false}
                    onChange={(value) => {
                      // console.log(value);
                      setSearchTextCostCenter('');
                    }}
                    onSearch={(value) => {
                      setSearchTextCostCenter(value);
                    }}
                    placeholder={t.depreciationCostCenter}
                    options={generateSelectOptions(costCenters)}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} md={12} xl={8}>
                <Form.Item
                  name="capital_work_in_progress_account"
                  label={t.capitalWorkInProgressAccount}
                  // rules={[{ required: true }]}
                >
                  <Select
                    showSearch
                    allowClear
                    filterOption={false}
                    onChange={(value) => {
                      // console.log(value);
                      setSearchtextAccount('');
                    }}
                    onSearch={(value) => {
                      setSearchtextAccount(value);
                    }}
                    placeholder={t.capitalWorkInProgressAccount}
                    options={generateSelectOptions(accountsList)}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} md={12} xl={8}>
                <Form.Item
                  name="asset_received_but_not_billed"
                  label={t.assetReceivedButNotBilled}
                  // rules={[{ required: true }]}
                >
                  <Select
                    showSearch
                    allowClear
                    filterOption={false}
                    onChange={(value) => {
                      // console.log(value);
                      setSearchtextAccount('');
                    }}
                    onSearch={(value) => {
                      setSearchtextAccount(value);
                    }}
                    placeholder={t.assetReceivedButNotBilled}
                    options={generateSelectOptions(accountsList)}
                  />
                </Form.Item>
              </Col>
              <Col
                xs={24}
                md={12}
                xl={8}
                className="flex items-center justify-start"
              >
                <Form.Item
                  name="auto_exchange_rate_revaluation"
                  valuePropName="checked"
                  className="margin-bottom-0"
                >
                  <Checkbox>{t.autoExchangeRateRevaluation}</Checkbox>
                </Form.Item>
              </Col>

              {/* <Col xs={24} md={12} xl={8}>
                <Form.Item
                  name="default_in_transit_warehouse"
                  label={t.defaultInTransitWarehouse}
                  // rules={[{ required: true }]}
                >
                  <Select
                    showSearch
                    allowClear
                    filterOption={false}
                    onChange={(value) => {
                      // console.log(value);
                      setSearchTextWarehouse('');
                    }}
                    onSearch={(value) => {
                      setSearchTextWarehouse(value);
                    }}
                    placeholder={t.defaultInTransitWarehouse}
                    options={generateSelectOptions(warehouses)}
                  />
                </Form.Item>
              </Col> */}

              {/* <Col xs={24} md={12} xl={8}>
                <Form.Item
                  name="unrealized_exchange_gain_loss_account"
                  label={t.exchangeGainLossAccount}
                  // rules={[{ required: true }]}
                >
                  <Select
                    showSearch
                    allowClear
                    filterOption={false}
                    onChange={(value) => {
                      // console.log(value);
                      setSearchtextAccount('');
                    }}
                    onSearch={(value) => {
                      setSearchtextAccount(value);
                    }}
                    placeholder={t.exchangeGainLossAccount}
                    options={generateSelectOptions(accountsList)}
                  />
                </Form.Item>
              </Col> */}

              {/* <Col xs={24} md={12} xl={8}>
                <Form.Item
                  name="default_in_transit_warehouse"
                  label={t.defaultInTransitWarehouse}
                  // rules={[{ required: true }]}
                >
                  <Select
                    showSearch
                    allowClear
                    filterOption={false}
                    onChange={(value) => {
                      // console.log(value);
                      setSearchTextWarehouse('');
                    }}
                    onSearch={(value) => {
                      setSearchTextWarehouse(value);
                    }}
                    placeholder={t.defaultInTransitWarehouse}
                    options={generateSelectOptions(warehouses)}
                  />
                </Form.Item>
              </Col> */}
            </Row>
            <div className="form-btns">
              <Button
                type="primary"
                ghost
                onClick={() => {
                  navigate(-1);
                }}
              >
                {t.Cancel}
              </Button>
              <Button type="primary" htmlType="submit" loading={loadingAdd}>
                {t.edit}
              </Button>
            </div>
          </Form>
        </Card>
      </div>
    </>
  );
};

export default EditProfile;
